import React, { useEffect, useMemo, useState } from "react";
import AdminLayout from "../../Layout/index.jsx";
import { useParams } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import {
  useGetClustersByCampusQuery,
  useGetStaffByEmailIdQuery,
} from "../../../../graphql/generated.tsx";
import { auth } from "../../../../utils/firebase.js";
import Loader from "../../../../components/Loader.jsx";
import Pagination from "../../../../components/Pagination/index.jsx";

const LeetcodeClusterListing = () => {
  const { campusName } = useParams();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [isLoad, setIsLoad] = useState(true);
  const limit = 10;

  const [user, setUser] = useState();

  useEffect(() => {
    setTimeout(() => {
      setIsLoad(false);
    }, 2000);
  }, []);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);
  const userRole = user
    ? JSON.parse(user?.reloadUserInfo?.customAttributes).role
    : null;

  const { data: staffData, loading: staffLoading } = useGetStaffByEmailIdQuery({
    variables: { email: user?.email },
  });

  const { data, refetch } = useGetClustersByCampusQuery({
    variables: { campusName, searchTerm, page: 1, limit: 200 },
  });

  const availableClusters = useMemo(() => {
    const raw = data?.getClustersByCampus;
    if (!raw) return [];
    if (userRole === "staff" && !staffData?.getStaffByEmailId?.isAdminStaff) {
      const ids = staffData?.getStaffByEmailId?.clusterIds || [];
      return raw.filter((cluster) => ids.includes(cluster.id));
    }
    return raw;
  }, [data?.getClustersByCampus, userRole, staffData?.getStaffByEmailId]);

  const totalPages = Math.max(1, Math.ceil(availableClusters.length / limit));
  const pagedClusters = availableClusters.slice(
    (page - 1) * limit,
    page * limit
  );

  const handleSearch = (e) => {
    const v = e.target.value;
    setSearchTerm(v);
    setPage(1);
    refetch({ campusName, searchTerm: v, page: 1, limit: 200 });
  };

  const handlePageChange = (newPage) => setPage(newPage);

  return (
    <AdminLayout>
      {isLoad ? (
        <div className="flex items-center justify-center h-screen">
          <Loader />
        </div>
      ) : (
      <div className="max-w-full p-5">
        <div className="flex items-center justify-between mb-8 max-md:flex-col max-md:gap-4">
          <div className="flex items-center">
            <button
              onClick={() => window.history.back()}
              className="text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <IoMdArrowRoundBack className="w-6 h-6" />
            </button>
            <div className="ml-2 text-2xl font-bold max-md:text-lg">
              {campusName} Clusters
            </div>
          </div>
          <div className="w-full mt-2 md:w-auto">
            <input
              type="text"
              placeholder="Search by name"
              value={searchTerm}
              onChange={handleSearch}
              className="w-full p-2 border border-gray-300 rounded-md md:max-w-xs"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6 mt-10 md:grid-cols-2 lg:grid-cols-3">
          {pagedClusters?.map((cluster) => (
            <div
              key={cluster.id}
              className="p-6 bg-white rounded-lg shadow-md cursor-pointer hover:shadow-lg"
              onClick={() => navigate(`${cluster.id}`)}
            >
              <h3 className="mb-2 text-xl font-semibold">{cluster.name}</h3>
              <p className="text-gray-700">Enrollee: {cluster.studentCount}</p>
            </div>
          ))}
        </div>

        <Pagination
          currentPage={page}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </div>
      )}
    </AdminLayout>
  );
};

export default LeetcodeClusterListing;
